import { __generator } from "tslib";
import React from 'react';
import { call, all, put, take, select, race } from 'redux-saga/effects';
import { request } from '../../xhr';
import { actions as StreamActions } from '../../Stream';
import { getCurrentStreamId, getCurrentGallection, getCurrentSubfolder, getCurrentMediaSource, getCurrentTier, } from '../selectors';
import { deselectMulti } from '../actions';
import updateGallectionSize from './updateGallectionSize';
import { isPremiumGallection, getPremiumGallectionType, } from '../../utils/gallections';
import { pushGlobalConfirmationModalForMM, confirmYes, confirmNo, } from '../../Modals/redux/actionCreators';
import { PremiumTrash, TrashCan } from '@wix/da-ds/pkg/Icons/Confirmations';
import { GallectionType } from '../../types/gallection';
import { MediaSourceType } from '../types';
import { getDeviationEntityIds } from '../../redux/normalizr/schemas/deviation';
import { deleteDeviation } from '../../redux/deviations/actionCreators';
function doConfirmationIfNeeded(_a) {
    var isTierContent, folderType, titleTransKey, textTransKey, isConfirmed;
    var mediaSourceType = _a.mediaSourceType, currentGallection = _a.currentGallection, deviations = _a.deviations;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                if (mediaSourceType === MediaSourceType.CUSTOM_SET) {
                    return [2 /*return*/, true];
                }
                isTierContent = [
                    MediaSourceType.TIER_DEVIATIONS,
                    MediaSourceType.TIER_POSTS,
                ].includes(mediaSourceType);
                folderType = isTierContent
                    ? 'tier'
                    : getPremiumGallectionType(currentGallection) || 'regular';
                switch (folderType) {
                    case 'tier':
                        titleTransKey =
                            deviations.length > 1
                                ? 'mediapopup.confirmationPopup.removeDeviation.title.tier.multi'
                                : 'mediapopup.confirmationPopup.removeDeviation.title.tier';
                        textTransKey =
                            deviations.length > 1
                                ? 'mediapopup.confirmationPopup.removeDeviation.text.tier.multi'
                                : 'mediapopup.confirmationPopup.removeDeviation.text.tier';
                        break;
                    case 'paid':
                        titleTransKey =
                            deviations.length > 1
                                ? 'mediapopup.confirmationPopup.removeDeviation.title.paid.multi'
                                : 'mediapopup.confirmationPopup.removeDeviation.title.paid';
                        textTransKey =
                            deviations.length > 1
                                ? 'mediapopup.confirmationPopup.removeDeviation.text.paid.multi'
                                : 'mediapopup.confirmationPopup.removeDeviation.text.paid';
                        break;
                    case 'watchers':
                        titleTransKey =
                            deviations.length > 1
                                ? 'mediapopup.confirmationPopup.removeDeviation.title.watchers.multi'
                                : 'mediapopup.confirmationPopup.removeDeviation.title.watchers';
                        textTransKey =
                            deviations.length > 1
                                ? 'mediapopup.confirmationPopup.removeDeviation.text.watchers.multi'
                                : 'mediapopup.confirmationPopup.removeDeviation.text.watchers';
                        break;
                    default:
                        titleTransKey =
                            deviations.length > 1
                                ? 'mediapopup.confirmationPopup.removeDeviation.title.multi'
                                : 'mediapopup.confirmationPopup.removeDeviation.title';
                        switch (currentGallection.type) {
                            case GallectionType.STASH:
                                textTransKey =
                                    deviations.length > 1
                                        ? 'mediapopup.confirmationPopup.removeDeviation.text.stash.multi'
                                        : 'mediapopup.confirmationPopup.removeDeviation.text.stash';
                                break;
                            case GallectionType.COLLECTION:
                                textTransKey =
                                    deviations.length > 1
                                        ? 'mediapopup.confirmationPopup.removeDeviation.text.collection.multi'
                                        : 'mediapopup.confirmationPopup.removeDeviation.text.collection';
                                break;
                            case GallectionType.GALLERY:
                            default:
                                textTransKey =
                                    deviations.length > 1
                                        ? 'mediapopup.confirmationPopup.removeDeviation.text.gallery.multi'
                                        : 'mediapopup.confirmationPopup.removeDeviation.text.gallery';
                        }
                        break;
                }
                if (!isPremiumGallection(currentGallection)) return [3 /*break*/, 2];
                return [4 /*yield*/, put(pushGlobalConfirmationModalForMM({
                        titleTransKey: titleTransKey,
                        textTransKey: textTransKey,
                        confirmBtnLabelTransKey: 'mediapopup.confirmationPopup.removeDeviation.confirm',
                        cancelBtnLabelTransKey: 'popup.cancel',
                        confirmBtnType: 'danger',
                        icon: React.createElement(PremiumTrash, null),
                    }))];
            case 1:
                _b.sent();
                return [3 /*break*/, 4];
            case 2: return [4 /*yield*/, put(pushGlobalConfirmationModalForMM({
                    titleTransKey: titleTransKey,
                    textTransKey: textTransKey,
                    confirmBtnLabelTransKey: 'mediapopup.itemMenu.delete',
                    cancelBtnLabelTransKey: 'popup.cancel',
                    confirmBtnType: 'danger',
                    icon: React.createElement(TrashCan, null),
                }))];
            case 3:
                _b.sent();
                _b.label = 4;
            case 4: return [4 /*yield*/, race({
                    yes: take(confirmYes),
                    no: take(confirmNo),
                })];
            case 5:
                isConfirmed = (_b.sent()).yes;
                return [2 /*return*/, !!isConfirmed];
        }
    });
}
function removeDeviationsHandler(action) {
    var deviations, _a, streamId, currentGallection, currentTier, mediaSourceType, currentSubfolder, confirmed, deviationEntityIds, type, currentFolderId, deviationIds, data, tierId, deviationIds, data;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                deviations = action.payload;
                return [4 /*yield*/, select(function (state) { return ({
                        mediaSourceType: getCurrentMediaSource(state),
                        streamId: getCurrentStreamId(state),
                        currentGallection: getCurrentGallection(state),
                        currentTier: getCurrentTier(state),
                        currentSubfolder: getCurrentSubfolder(state),
                    }); })];
            case 1:
                _a = _b.sent(), streamId = _a.streamId, currentGallection = _a.currentGallection, currentTier = _a.currentTier, mediaSourceType = _a.mediaSourceType, currentSubfolder = _a.currentSubfolder;
                return [4 /*yield*/, call(doConfirmationIfNeeded, {
                        mediaSourceType: mediaSourceType,
                        currentGallection: currentGallection,
                        deviations: deviations,
                    })];
            case 2:
                confirmed = _b.sent();
                if (!confirmed) {
                    return [2 /*return*/];
                }
                deviationEntityIds = getDeviationEntityIds(deviations);
                return [4 /*yield*/, all([
                        put(StreamActions.deleteItems({ streamId: streamId, items: deviationEntityIds })),
                        put(deselectMulti(deviations)),
                    ])];
            case 3:
                _b.sent();
                if (!currentGallection) return [3 /*break*/, 8];
                type = currentGallection.type;
                if (!(type === 'stash')) return [3 /*break*/, 5];
                return [4 /*yield*/, all(deviations.map(function (deviation) { return put(deleteDeviation({ deviation: deviation })); }))];
            case 4:
                _b.sent();
                return [2 /*return*/];
            case 5:
                currentFolderId = currentSubfolder
                    ? currentSubfolder.folderId
                    : currentGallection.folderId;
                return [4 /*yield*/, call(updateGallectionSize, currentFolderId, -deviations.length)];
            case 6:
                _b.sent();
                deviationIds = deviations.map(function (deviation) { return deviation.deviationId; });
                data = {
                    type: type,
                    folderid: currentFolderId,
                    deviationids: deviationIds,
                };
                return [4 /*yield*/, call(request, {
                        method: 'post',
                        url: 'gallection/folders/remove_deviations',
                        data: data,
                    })];
            case 7:
                _b.sent();
                _b.label = 8;
            case 8:
                if (!currentTier) return [3 /*break*/, 10];
                tierId = currentTier.deviationId;
                deviationIds = deviations.map(function (deviation) { return deviation.deviationId; });
                data = {
                    tier_deviationid: tierId,
                    deviationids: deviationIds,
                };
                return [4 /*yield*/, call(request, {
                        method: 'post',
                        url: 'tier/deviation/remove',
                        data: data,
                    })];
            case 9:
                _b.sent();
                _b.label = 10;
            case 10: return [2 /*return*/];
        }
    });
}
export default removeDeviationsHandler;
//# sourceMappingURL=removeDeviations.js.map